import { render, staticRenderFns } from "./UserInteractions.vue?vue&type=template&id=12796aaa&scoped=true"
import script from "./UserInteractions.vue?vue&type=script&lang=js"
export * from "./UserInteractions.vue?vue&type=script&lang=js"
import style0 from "./UserInteractions.vue?vue&type=style&index=0&id=12796aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12796aaa",
  null
  
)

export default component.exports